import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Cycle } from '../models/cycle.model';
import { plainToInstance } from 'class-transformer';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CycleService {

  private apiUrl = `${environment.sgcApi}`;
  private cycleRoute = 'cycle';

  constructor(
    private httpClient: HttpClient
  ) { }

  getCycles(): Observable<Cycle[]> {
    let endpoint = `${this.apiUrl}${this.cycleRoute}`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(Cycle, data as Cycle[]);
    }));
  }
}
